<script setup lang=ts>
import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';
import Normal from './Normal.vue';
import Pinned from './Pinned.vue';
import Column from './Column.vue';

const { $fetch } = useFetch();

const { data } = useAsyncData(
  'home:information:number',
  () => $fetch('/popSpecialColumn/getInfoAndColumnCount', { method: 'post' }),
);
</script>

<template>
  <div class="h-642 flex gap-32">
    <Column class="flex-shrink-0" v-if="data?.columnCount" />
    <Pinned class="flex-shrink-0" v-else />
    <Normal class="flex-shrink-0" :is-selected="!!data?.columnCount" />
  </div>
</template>

<style lang="scss" scoped>
</style>
